export interface IMetadata {
  data: {
    hierarchy?: string[];
  };
}

export function isStorySharesDecodableContent(
  content: {
    content_type?: string;
    data?: {
      content_provider?: {
        slug?: string;
      };
    };
  },
  contentMetadata: IMetadata[],
): boolean {
  const isStorySharesArticle =
    content?.content_type === "ARTICLE" &&
    content?.data?.content_provider?.slug === "storyshares";

  const hasDecodableMetadata = isDecodableContent(contentMetadata);

  return isStorySharesArticle && hasDecodableMetadata;
}

export function isDecodableContent(contentMetadata: IMetadata[]): boolean {
  const hasDecodableMetadata = contentMetadata?.find((item) =>
    item?.data?.hierarchy?.includes("Decoding"),
  );
  return Boolean(hasDecodableMetadata);
}
